import React, { useContext, useEffect } from "react"
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";
import SkeletonHomeIndividual from "../../skeletons/SkeletonHome/SkeletonHomeIndividual";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { FlipBook } from "./flip-book";
import { useHistory } from "react-router-dom";
import { store } from "../../components/Store";

/**
 * Componente que muestra la página de inicio del usuario individual con pocos libros.
 * @param {Object} props - Props del componente.
 * @param {Object} props.data - Datos de la página de inicio del usuario.
 * @returns {JSX.Element} Elemento JSX 
 */
export const IndividualUserHome = ({ data }) => {
    const { textosSubSecciones: textosHome } = useObtenerSubsecciones('home');
    const textos = textosHome?.individual || {};
    const globalState = useContext(store);
    const isAuth = globalState?.state?.sesionActiva === 'SI';
    const books = Array.isArray(data?.data?.books) ? data?.data?.books : [];
    const username = globalState?.state?.username || 'N/A';
    const history = useHistory();

    useEffect(() => {
        if (data?.loaded && isAuth && books?.length <= 0 ) {
            history.push('/mi-panel/mi-coleccion')
        }
}, [books, isAuth, data])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    return (<section>
        {
            data?.fetching ?
                <SkeletonHomeIndividual />
                :
                <>
                    <section className="individual-header" id="individual-home">
                        <div className="individual-header-container">
                            <p tabIndex={0} className="focusable-secondary individual-header-description">
                                {textos?.bienvenido}{" "}
                                <span
                                    className="individual-header-course una-linea-texto d-block"
                                    id="individual-username"
                                >
                                    {username}
                                </span>
                            </p>
                            <img
                                role={'presentation'}
                                alt="Pesonaje Blop de bienvenido a tu biblioteca"
                                className="individual-header-image"
                                src={"/img/img-course.png"}
                            />
                        </div>
                    </section>

                    <section tabIndex={0} aria-label={`libros, ${books?.length} resultados`} className="focusable-secondary individual-books">
                        <div
                            className=" container-individual-books"
                            id="container-individual-books"
                        >
                            <LazyLoadComponent threshold={.5}>
                                {books?.map((book, i) => {
                                    return (
                                        <FlipBook
                                            key={`book${i}`}
                                            portada={book?.portada}
                                            titulo={book?.title}
                                            genero={book?.genero}
                                            autor={book?.author}
                                            editorial={book?.editorial}
                                            descripcion={book?.descripcion}
                                            url={book?.botonLeer?.split("/visor/?idLibro=")[1]}
                                        />
                                    );
                                })}
                            </LazyLoadComponent>


                        </div>
                    </section>
                </>

        }

    </section>)
}